export enum Modals {
  EDIT_PRODUCT = 'EDIT_PRODUCT',
  CREATE_PRODUCT = 'CREATE_PRODUCT',
  CREATE_COMPANY = 'CREATE_COMPANY',
  DELETE_COMPANIES = 'DELETE_COMPANIES',
  EDIT_COMPANY = 'EDIT_COMPANY',
  CREATE_CATEGORY = 'CREATE_CATEGORY',
  DELETE_CATEGORIES = 'DELETE_CATEGORIES',
}
